import Api from './index'
import { IRelation } from '../models/relation'
import { IUser } from '../models/user'

export const getUser = (relationId: IRelation['id'], userId: string) => Api<IUser>('GET', `relations/${relationId}/users/${userId}`)

export const updateUser = (relationId: IRelation['id'], userId: string, user: IUser, updates: Partial<IUser>) => Api<IUser>('PUT', `relations/${relationId}/users/${userId}`, { data: { ...user, ...updates } })
